<template>
  <div class="invoice-tax-rate-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费项：</span>
        </div>
        <el-select v-model="formData.itemCode" size="small" style="width: 280px">
          <el-option v-for="item in itemList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">开票名称：</span>
        </div>
        <el-input v-model="formData.invoiceName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">销方：</span>
        </div>
        <el-select v-model="formData.resellerId" size="small" style="width: 280px">
          <el-option v-for="item in resellerIdList" :key="item.resellerId"
                     :label="item.resellerName" :value="item.resellerId">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">是否允许用户自定义抬头：</span>
        </div>
        <div style="width: 220px;line-height: 32px;display: inline-block;">
          <el-switch v-model="isMobileSelectTitleState" active-text="是" inactive-text="否"></el-switch>
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">是否含税：</span>
        </div>
        <div style="width: 220px;line-height: 32px;display: inline-block;">
          <el-switch v-model="hsbzState" active-text="是" inactive-text="否"></el-switch>
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">是否简易税收：</span>
        </div>
        <div style="width: 220px;display: inline-block;">
          <el-switch v-model="formData.simpleTaxFlag" active-text="是" inactive-text="否" active-value="1" inactive-value="0"></el-switch>
        </div>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">不动产标识：</span>
        </div>
        <div style="width: 220px;display: inline-block;">
          <el-switch v-model="formData.realPropertyFlag" active-text="是" inactive-text="否" active-value="1" inactive-value="0"></el-switch>
        </div>
      </div>
      <div class="form-line" v-if="formData.realPropertyFlag === '1'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">不动产详细地址：</span>
        </div>
        <el-input v-model="formData.realPropertyAddress" size="small" style="width: 280px"/>
        <div style="color: #999999;line-height: 32px;">传对应省市区中文名称--需与行政区划名称一致，且必须包含 街、路、村、乡、镇、道 关键词</div>
      </div>

      <div class="form-line" v-if="hsbzState">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">税率：</span>
        </div>
        <el-input-number v-model="formData.taxRate" size="small" style="width: 280px" :precision="3" :step="0.001" controls-position="right"/>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">分类编码：</span>
        </div>
        <el-input v-model="formData.typeCode" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">单位：</span>
        </div>
        <el-input v-model="formData.unit" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../api/invoice'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'
  import UploadImgList from '../../../components/Input/UploadImgList'

  export default {
    components: {
      UploadImgList,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'invoice-tax-rate-add',
    data () {
      return {
        breadcrumb: [{
          value: '智慧凭证',
          name: 'invoice-over-view'
        }, {
          value: '税率管理'
        }],
        mainTitle: '添加税率配置',
        subheading: '',

        itemList: [],
        isMobileSelectTitleState: false,
        hsbzState: false,
        formData: {
          itemCode: '',
          itemName: '',
          invoiceName: '',
          taxRate:  '',
          hsbz: '',
          typeCode: '',
          resellerId: '',
          resellerName: '',
          isMobileSelectTitle: '',
          unit: '',
          simpleTaxFlag: '0',
          realPropertyFlag: '0',
          realPropertyAddress: ''
        },
        accountList: [],
        responsiblePersonList: [],
        resellerIdList: []
      }
    },
    created () {
      this.getInvoiceItemList()
      this.getConfiguration()
    },
    methods: {
      getInvoiceItemList () {
        this.$axios.get(`${api.getInvoiceItemList}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let list = res.data.data
              this.itemList = list
            }
          })
          .catch(errorHandler('查询失败'))
      },

      getConfiguration () {
        this.$axios.get(`${api.getConfiguration}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let list = res.data.data
              this.resellerIdList = list
            }
          })
          .catch(errorHandler('查询失败'))
      },

      toManagePage () {
        this.$router.push({
          name: 'invoice-tax-rate-manage'
        })
      },

      confirm () {
        if (!this.formData.itemCode) {
          nError('请选择缴费项')
          return false
        }
        if (!this.formData.invoiceName) {
          nError('请输入开票名称')
          return false
        }
        if (!this.formData.resellerId) {
          nError('请选择销方')
          return false
        }
        if (this.hsbzState && !this.formData.taxRate) {
          nError('请输入税率')
          return false
        }
        if (this.formData.realPropertyFlag === '1'&&!this.formData.realPropertyAddress) {
          nError('请输入不动产详细地址')
          return false
        }
        if (this.formData.realPropertyFlag === '0'){
          this.formData.realPropertyAddress = '';
        }
        if (!this.formData.typeCode) {
          nError('请输入分类编码')
          return false
        }
        this.itemList.map(v => {
          if (v.code === this.formData.itemCode) {
            this.formData.itemName = v.name
          }
        })
        this.resellerIdList.map(v => {
          if (v.resellerId === this.formData.resellerId) {
            this.formData.resellerName = v.resellerName
          }
        })
        this.formData.hsbz = this.hsbzState ? '1' : '0'
        this.formData.isMobileSelectTitle = this.isMobileSelectTitleState ? '1' : '0'
        let formData = JSON.parse(JSON.stringify(this.formData));
        if (!this.hsbzState) {
          formData.taxRate = '0';
        }
        this.$axios.post(api.addInvoiceTaxRate, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toManagePage()
            }
          })
          .catch(errorHandler('添加失败'))
      },
      cancel () {
        this.toManagePage()
      }
    }
  }
</script>

<style lang="less">
  .invoice-tax-rate-add {
    .el-input-number.is-controls-right .el-input__inner {
      text-align: left;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/Invoice/InvoiceTaxRate/InvoiceTaxRateAdd.vue